import { render, staticRenderFns } from "./digital_license_public.vue?vue&type=template&id=36a244a4&scoped=true&"
import script from "./digital_license_public.vue?vue&type=script&lang=js&"
export * from "./digital_license_public.vue?vue&type=script&lang=js&"
import style0 from "./digital_license_public.vue?vue&type=style&index=0&id=36a244a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a244a4",
  null
  
)

export default component.exports